import { render, staticRenderFns } from "./Disease.vue?vue&type=template&id=a846038e&scoped=true"
import script from "./Disease.vue?vue&type=script&lang=js"
export * from "./Disease.vue?vue&type=script&lang=js"
import style0 from "./Disease.vue?vue&type=style&index=0&id=a846038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a846038e",
  null
  
)

export default component.exports